import { PropsWithChildren, useLayoutEffect, useRef, useState } from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';

const Container = styled(Box)<{ height: number }>`
	transition: 1s cubic-bezier(0, 1, 0, 1) height;
	height: ${(props) => props.height};
	overflow: hidden;
`;

const Clip = styled(Box)<{ expanded?: boolean }>`
	transition:
		1s cubic-bezier(0, 1, 0, 1) transform,
		0.2s linear opacity;
	transform: ${(props) => (props.expanded ? 'none' : 'scaleY(0)')};
	transform-origin: top center;
	opacity: ${(props) => (props.expanded ? 1 : 0)};
`;

export function Expand(props: PropsWithChildren<{ expanded?: boolean }>) {
	const ref = useRef<HTMLDivElement>(null);
	const [height, setHeight] = useState<number>(0);

	useLayoutEffect(() => {
		const observer = new ResizeObserver((entries) => {
			const height = entries[0].contentRect.height;

			setHeight(height);
		});

		observer.observe(ref.current!);

		return () => observer.disconnect();
	}, []);

	return (
		<Container height={props.expanded ? height : 0}>
			<Clip expanded={props.expanded}>
				<Box ref={ref}>{props.children}</Box>
			</Clip>
		</Container>
	);
}
